import request from "@/utils/request";
export function fetchList(data) {
  return request({
    url: "/whg-park/api/invice/list",
    method: "post",
    data: data
  });
} // export function fetchDetail(data) {
//   return request({
//     url: "/whg-park/api/invice/get",
//     method: "post",
//     data
//   });
// }
// export function fetchDelete(ids) {
//   var data = { ids };
//   return request({
//     url: "/whg-park/api/invice/delete",
//     method: "post",
//     data
//   });
// }
// export function fetchCreate(data) {
//   return request({
//     url: "/whg-park/api/invice/insert",
//     method: "post",
//     data
//   });
// }
// export function fetchUpdate(data) {
//   return request({
//     url: "/whg-park/api/invice/update",
//     method: "post",
//     data
//   });
// }